import { ClientInfoSectionProps } from "@repo/core/components/receipt/sections/ClientInfoSection/types";
import { StoreInfoSectionProps } from "@repo/core/components/receipt/sections/StoreInfoSection/types";
import { TransactionInfoSectionProps } from "@repo/core/components/receipt/sections/TransactionInfoSection/types";
import { TransactionOperationEnum } from "@repo/core/enums/receipts";

export const transactionInfoMock: TransactionInfoSectionProps = {
  title: "Dados Gerais",
  icon: "list",
  dateTime: new Date(),
  paymentMethod: "credit",
  value: 1250,
  interestValue: 217.45,
  totalValue: 1467.45,
  installmentsQuantity: 5,
  installmentValue: 293.49,
  operation: TransactionOperationEnum.WITHDRAW
};
export const storeInfoMock: StoreInfoSectionProps = {
  title: "Destino",
  icon: "circle-arrow-down",
  name: "Mobly Comércio Varejista Ltda",
  cnpj: "97.506.444/0004-90",
  phone: "(11) 3339-0609",
  address: "Av. João Pinto",
  nsuTerminal: "10501",
  nsuProcessor: "1922619",
  date: "11/03/2024",
  time: "15:03:40"
};
export const clientInfoMock: ClientInfoSectionProps = {
  title: "Origem",
  icon: "circle-arrow-up",
  name: "João Vitor Rodrigues da Silva",
  card: "••••2110",
  fone: "(11) 3339-0609"
};
